// extracted by mini-css-extract-plugin
export default {"text":"Title_text__w37LY","wiggle":"Title_wiggle__WqLX8"};